<template>
  <div class="sidebar">
    <div class="sidebar__pull">
      <div class="sidebar__header header">
        <router-link :to="{ name: 'index' }" exact>
          <img src="../assets/pos_logo.jpg" alt="logo" />
        </router-link>
        <div class="header__search">
          <form>
            <input id="seach" name="seach" type="search" class="base-input" :placeholder="$t('search')" />
          </form>
        </div>
      </div>
      <div class="sidebar__content">
        <ul class="nav">
          <li v-for="(item, index) in sider" :key="index">
            <router-link :to="{ name: item.link }"> <UiBaseIcon :iconName="item.icon" height="18" width="18" />{{ item.label }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon'
import sildebarData from '@/constants/slidebar'

export default {
  name: 'Sidebar',
  components: {
    UiBaseIcon
  },
  data () {
    return {
      sider: sildebarData
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  width: 216px;
  top: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  background-color: $color-black-100;
  z-index: 13;
  transition: all 0.28s ease;
  transform: translate3d(-185px, 0, 0);
  overflow-y: hidden;
  overflow-x: hidden;

  &:hover {
    overflow-y: auto;
  }

  &__content {
    .nav li {
      border-top: 1px solid $color-black-200;
    }
    .nav a {
      white-space: nowrap;
      color: $color-gray-450;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      padding: 14px 22px;
      text-decoration: none;
      white-space: nowrap;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
    .nav a:hover {
      color: $color-green-50;
    }
    .nav a:hover svg {
      fill: $color-green-50;
    }
    .is-active {
      color: $color-green-50 !important;
    }
  }
  &__pull {
    transform: translate3d(170px, 0, 0);
    transition: all 0.28s ease;
  }
  &__header {
    padding: 25px 20px;
  }
  .header {
    &__search {
      margin: 32px 0 16px;
      visibility: hidden;
      input {
        box-shadow: none;
        background-color: transparent;
        border: 1px solid $color-black-200;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
        height: 38px;
        padding-left: 30px;
        padding-right: 30px;
      }
    }
  }
}
.sidebar:hover {
  width: 280px;
  transform: unset;
}

.sidebar:hover .sidebar__pull {
  transform: unset;
}
.sidebar:hover .header__search {
  visibility: visible;
}

@include media_tablet {
  .sidebar {
    display: none;
  }
}
</style>
